import React from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import ModelCard from "@/components/ModelCard";
import FinalCTA from "@/components/FinalCTA";
import { MODELS } from "@/data/content";

const ModelsOverview = () => {
  return (
    <>
      <SEO />
      <PageHero
        crumbs={[{ label: "Početna", to: "/" }, { label: "Modeli kontejnera" }]}
        title="Modeli kontejnera"
        lead="Pregled svih modela koje izrađujemo — standardni, stambeni, kancelarijski, sanitarni, građevinski, portirnice i pomoćni objekti."
      />
      <section className="section" data-testid="models-overview">
        <div className="container-rb">
          <div className="grid-3">
            {MODELS.map((m) => (
              <ModelCard key={m.slug} model={m} />
            ))}
          </div>
        </div>
      </section>
      <FinalCTA />
    </>
  );
};

export default ModelsOverview;
